/** The available wireframe UX variants for the medical questionnaire step. */
enum MedicalUxVersion {
  CombinedPage = "medicalUxVersion.combinedPage",
  OneAtATime = "medicalUxVersion.oneAtATime",
  AutoScroll = "medicalUxVersion.autoScroll"
}

export default MedicalUxVersion;
